import {
  httpRequest as sharedHttpRequest,
  type HttpRequestConfig,
} from '@utils/httpClient';

// Re-export all types
export type {
  HttpMethod,
  HttpRequestData,
  HttpRequestParams,
  ApiBaseType,
  HttpRequestConfig,
  ErrorResponse,
  CustomAxiosError,
} from '@utils/httpClient';

// Wrapper function that provides environment-specific URLs
export const httpRequest = <T>(config: HttpRequestConfig): Promise<T> => {
  return sharedHttpRequest<T>({
    ...config,
    baseUrls: {
      INTEGRATION: import.meta.env.VITE_INTEGRATION_URL,
      VOYCE: import.meta.env.VITE_VOYCE_URL,
      JAVA: import.meta.env.VITE_CLINICAL_API_URL, // Default Java API URL
    },
  });
};
